// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';
/**
 * 基础菜单
 */
//主页
import Home from '@/views/home/Home';


/**
 * 生产管理
 */
// 销售订单
import Goods from '@/views/goods/Goods';
// 装配工单
import AssemblyWorkOrder from '@/views/assemblyWorkOrder/main-layout';
//工单
import Order from '@/views/order/Order';
//任务
import Task from '@/views/task/Task';
//报工
import WorkReport from '@/views/workReport/WorkReport';


/**
 * 库存管理
 */

//入库单
import WarehousingOrder from '@/views/stockManagement/warehousingOrder/WarehousingOrder';
//出库单
import OutboundOrder from '@/views/stockManagement/outboundOrder/OutboundOrder';
//库存收发明细
import StockRDDetail from '@/views/stockManagement/stockRDDetail/StockRDDetail';

//库存余额
import StockBalance from '@/views/stockManagement/stockBalance/StockBalance';

//进销存汇总
import InventorySummary from '@/views/stockManagement/inventorySummary/InventorySummary';

/**
 * 基础数据
 */
//产品定义
import ProductDefinition from '@/views/basicData/productDefinition/ProductDefinition';
//物料清单
import MaterialList from '@/views/basicData/materialList/MaterialList';
//单位
import Unit from '@/views/basicData/unit/Unit';
//不良品相
import DefectiveProduct from '@/views/basicData/defectiveProduct/DefectiveProduct';
//工序
import WorkProcedure from '@/views/basicData/workProcedure/WorkProcedure';
//工艺路线
import ProcessRouting from '@/views/basicData/processRouting/ProcessRouting';
//绩效工资配置
import PerformAllocation from '@/views/basicData/performAllocation/PerformAllocation';


/**
 * 自定义配置
 */
//产品
import production from '@/views/customSetting/production/production';
//工序
import process from '@/views/customSetting/process/process';
//工单
import order from '@/views/customSetting/order/order';
//报工
import workReport from '@/views/customSetting/workReport/workReport';
//出入库单
import inOutTicket from '@/views/customSetting/inOutTicket/inOutTicket';
import outTicket from '@/views/customSetting/outTicket/outTicket';

//库存收发明细
import inOutDetail from '@/views/customSetting/inOutDetail/inOutDetail';
//用户
import user from '@/views/customSetting/user/user';
//自定义表单
import customForm from '@/views/customSetting/customForm/customForm';
//自定义编号规则
import customRule from '@/views/customSetting/customRule/customRule';



/**
 * 系统配置
 */
//部门
import deptSys from '@/views/systemSetting/deptSys/deptSys';
//用户
import userSys from '@/views/systemSetting/userSys/userSys';
//工厂
import factorySys from '@/views/systemSetting/factorySys/factorySys';


/**
 * 车间看板
 */
// 车间看板
import workshopSignage from '@/views/workshopSignage/workshopSignage/MainLayout';


/**
 * 报表
 */
import FinishedProduction from '@/views/home/report/FinishedProduction';
import FinishedProcessProduction from '@/views/home/report/FinishedProcessProduction';
import FinishedProcessProductionMonth from '@/views/home/report/FinishedProcessProductionMonth';
import FinishedProductionMonth from '@/views/home/report/FinishedProductionMonth';
import NoGoodDistribution from '@/views/home/report/NoGoodDistribution';
import NoGoodDistributionMonth from '@/views/home/report/NoGoodDistributionMonth';
import StaffWork from '@/views/home/report/StaffWork';
import StaffWorkMonth from '@/views/home/report/StaffWorkMonth';






/* 在创建router实例对象之前，手动覆盖原型链的push来吞掉报错catch */
// 先存储默认底层的push
const originPush = Router.prototype.push
    // 覆盖原型链的push
Router.prototype.push = function(location, resolve, reject) {
    // this:路由实例对象

    // 判断用户有没有传后面两个可选参数
    if (resolve || reject) {
        return originPush.call(this, location, resolve, reject)
    } else { // 用户只传了第一个参数
        /*
        默认底层： catch()方法代码  throw err : 抛出异常
        吞掉报错原理： 重写catch()方法,把默认底层的 throw err给去掉，就不会抛出异常
        */
        return originPush.call(this, location).catch(err => {
            //  throw err
        })
    }
}

Vue.prototype._headerStyle = function() {
    return {
        'background': '#F4F4F4',
        'color': '#333'
    }
}

// 启用路由
Vue.use(Router);

// 导出路由
export default new Router({
    routes: [{
            path: '/',
            name: '',
            component: login,
            hidden: true,
            meta: {
                requireAuth: false
            }
        }, {
            path: '/login',
            name: '登录',
            component: login,
            hidden: true,
            meta: {
                requireAuth: false
            }
        }, {
            path: '/index',
            name: '首页',
            component: index,
            iconCls: 'el-icon-tickets',
            children: [{
                    path: '/home/Home',
                    name: '主页',
                    component: Home,
                    meta: {
                        requireAuth: true
                    },
                },
                {
                    path: '/goods/Goods',
                    name: '销售订单',
                    component: Goods,
                    meta: {
                        requireAuth: true
                    },
                }, {
                    path: '/assemblyWorkOrder/main-layout',
                    name: '装配工单',
                    component: AssemblyWorkOrder,
                    meta: {
                        requireAuth: true
                    },
                },
                {
                    path: '/order/Order',
                    name: '工单',
                    component: Order,
                    meta: {
                        requireAuth: true
                    },
                },
                {
                    path: '/task/Task',
                    name: '任务',
                    component: Task,
                    meta: {
                        requireAuth: true
                    },
                },
                {
                    path: '/workReport/workReport',
                    name: '报工',
                    component: WorkReport,
                    meta: {
                        requireAuth: true
                    },
                },
                {
                    path: '/customSetting/workReport',
                    name: '报工',
                    component: workReport,
                    meta: {
                        requireAuth: true
                    },
                },

                {
                    path: '/warehousingOrder/WarehousingOrder',
                    name: '入库单',
                    component: WarehousingOrder,
                    meta: {
                        requireAuth: true
                    },
                },
                {
                    path: '/outboundOrder/OutboundOrder',
                    name: '出库单',
                    component: OutboundOrder,
                    meta: {
                        requireAuth: true
                    },
                },
                {
                    path: '/stockRDDetail/StockRDDetail',
                    name: '库存收发明细',
                    component: StockRDDetail,
                    meta: {
                        requireAuth: true
                    },
                },
                {
                    path: '/stockBalance/StockBalance',
                    name: '库存余额',
                    component: StockBalance,
                    meta: {
                        requireAuth: true
                    },
                },
                {
                    path: '/inventorySummary/InventorySummary',
                    name: '库存统计',
                    component: InventorySummary,
                    meta: {
                        requireAuth: true
                    },
                },

                {
                    path: '/productDefinition/ProductDefinition',
                    name: '产品定义',
                    component: ProductDefinition,
                    meta: {
                        requireAuth: true
                    },
                },

                {
                    path: '/materialList/MaterialList',
                    name: '物料清单',
                    component: MaterialList,
                    meta: {
                        requireAuth: true
                    },
                },

                {
                    path: '/unit/Unit',
                    name: '单位',
                    component: Unit,
                    meta: {
                        requireAuth: true
                    },
                },
                {
                    path: '/defectiveProduct/DefectiveProduct',
                    name: '不良品项',
                    component: DefectiveProduct,
                    meta: {
                        requireAuth: true
                    },
                },
                {
                    path: '/workProcedure/WorkProcedure',
                    name: '工序',
                    component: WorkProcedure,
                    meta: {
                        requireAuth: true
                    },
                },
                {
                    path: '/processRouting/ProcessRouting',
                    name: '工艺路线',
                    component: ProcessRouting,
                    meta: {
                        requireAuth: true
                    },
                },
                {
                    path: '/performAllocation/PerformAllocation',
                    name: '绩效工资配置',
                    component: PerformAllocation,
                    meta: {
                        requireAuth: true
                    },
                },
                /**
                 * 自定义配置
                 */
                {
                    path: '/production/production',
                    name: '产品',
                    component: production,
                    meta: {
                        requireAuth: true
                    },
                },
                {
                    path: '/process/process',
                    name: '工序-自定义配置',
                    component: process,
                    meta: {
                        requireAuth: true
                    },
                },
                {
                    path: '/orderSetting/orderSetting',
                    name: '工单-自定义配置',
                    component: order,
                    meta: {
                        requireAuth: true
                    },
                },

                {
                    path: '/workReport/workReport',
                    name: '报工-自定义配置',
                    component: workReport,
                    meta: {
                        requireAuth: true
                    },
                },

                {
                    path: '/inOutTicket/inOutTicket',
                    name: '入库单',
                    component: inOutTicket,
                    meta: {
                        requireAuth: true
                    },
                },

                {
                    path: '/outTicket/outTicket',
                    name: '出库单',
                    component: outTicket,
                    meta: {
                        requireAuth: true
                    },
                },

                {
                    path: '/inOutDetail/inOutDetail',
                    name: '库存收发明细',
                    component: inOutDetail,
                    meta: {
                        requireAuth: true
                    },
                },

                {
                    path: '/user/user',
                    name: '用户',
                    component: user,
                    meta: {
                        requireAuth: true
                    },
                },

                {
                    path: '/customForm/customForm',
                    name: '自定义表单',
                    component: customForm,
                    meta: {
                        requireAuth: true
                    },
                },

                {
                    path: '/customRule/customRule',
                    name: '自定义编号规则',
                    component: customRule,
                    meta: {
                        requireAuth: true
                    },
                },

                /**
                 * 系统配置
                 */

                {
                    path: '/systemSetting/deptSys',
                    name: '部门',
                    component: deptSys,
                    meta: {
                        requireAuth: true
                    },
                },
                {
                    path: '/systemSetting/userSys',
                    name: '用户',
                    component: userSys,
                    meta: {
                        requireAuth: true
                    },
                },
                {
                    path: '/systemSetting/factorySys',
                    name: '工厂',
                    component: factorySys,
                    meta: {
                        requireAuth: true
                    },
                },
                /**
                 * 报表
                 */
                {
                    path: '/home/report/FinishedProduction',
                    name: '当天产量统计-按成品',
                    component: FinishedProduction,
                    meta: {
                        requireAuth: true
                    },
                },
                {
                    path: '/home/report/FinishedProcessProduction',
                    name: '当天产量统计-按工序和成品',
                    component: FinishedProcessProduction,
                    meta: {
                        requireAuth: true
                    },
                },
                {
                    path: '/home/report/FinishedProcessProductionMonth',
                    name: '当月产量统计-按工序和成品',
                    component: FinishedProcessProductionMonth,
                    meta: {
                        requireAuth: true
                    },
                },
                {
                    path: '/home/report/FinishedProductionMonth',
                    name: '当月产量统计-按成品',
                    component: FinishedProductionMonth,
                    meta: {
                        requireAuth: true
                    },
                },
                {
                    path: '/home/report/NoGoodDistribution',
                    name: '当天不良品项分布',
                    component: NoGoodDistribution,
                    meta: {
                        requireAuth: true
                    },
                },
                {
                    path: '/home/report/NoGoodDistributionMonth',
                    name: '当月不良品项分布',
                    component: NoGoodDistributionMonth,
                    meta: {
                        requireAuth: true
                    },
                },
                {
                    path: '/home/report/StaffWork',
                    name: '今天员工报工统计',
                    component: StaffWork,
                    meta: {
                        requireAuth: true
                    },
                },
                {
                    path: '/home/report/StaffWorkMonth',
                    name: '本月员工报工统计',
                    component: StaffWorkMonth,
                    meta: {
                        requireAuth: true
                    },
                },

            ]
        },
        /**
         * 车间看板
         */
        {
            path: '/workshopSignage/workshopSignage',
            name: '车间看板',
            component: workshopSignage,
            meta: {
                requireAuth: true
            },
        },
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js